const formatUsername = (username: string): string => {
  const splitUsername = username.split(".");
  const name =
    splitUsername[0].charAt(0).toUpperCase() + splitUsername[0].slice(1);
  const surename =
    splitUsername[1].charAt(0).toUpperCase() + splitUsername[1].slice(1);
  return `${name} ${surename}`;
};

export default formatUsername;
